import React, { useState } from "react";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import { handlePostRequest } from "../../../services/PostTemplate";
import { useDispatch } from "react-redux";
import Outstanding from "../../../modals/Outstanding";
import AddPackageDialog from "./AddPackageDialog";
import ChangeStatusDialog from "./changeStatusDialog";
import PackageDetail from "../PackageDetail";
import UploadImageDialog from "./UploadImageDialog";
import SofStop from "../../../modals/SofStop";
import BulkFlightDialog from "./bulkFlightDialog";
import ScanPackage from "../../flight/ScanPackage";
import ScanDialog from "./ScanDialog";
import styles from "../packageDetail.module.scss";

function DialogsMain({
    showOutstanding,
    setShowOutstanding,
    setShowDialog,
    showDialog,
    setShowChangeDialog,
    showChangeDialog,
    setFlightDialog,
    FlightDialog,
    setPackageDetail,
    packageDetail,
    setUploadShow,
    uploadShow,
    setShowSoftStop,
    showSoftStop,
    selectedRow,
    updates,
    wayBills,
    pack,
    handles,
    getBrands,
    scanPending,
    setScanPending,
    trackingNumber,
    unpaid
}) {

    const dispatch=useDispatch()
    const onHideOutstanding = () => {
        setShowOutstanding(false);
        localStorage.removeItem("Zaziolog");
    };

    const onSuccessOutstanding = () => {
        setShowOutstanding(false);
        localStorage.removeItem("Zaziolog");
    };

    const onHideTyreBrandsDialog = () => {
        setShowDialog(false);
    };

    const onsuccess = () => {
        onHideTyreBrandsDialog();
        toast.success("package added.");
        window.location.reload();
    };

    const onHideChangeDialog = () => {
        setShowChangeDialog(false);
    };

    const onsuccessChange = () => {
        onHideChangeDialog();
        toast.success("Status Changed.");
        window.location.reload();
    };

    const onHideFlightDialog = () => {
        setFlightDialog(false);
    };

    const onsuccessFlight = () => {
        onHideFlightDialog();
        toast.success("Flight Number Changed.");
        window.location.reload();
    };

    const onsuccessPackageDetail = () => {
        onHideFlightDialog();
        toast.success("Flight Number Changed.");
        window.location.reload();
    };

    const onHidePackageDetail = () => {
        setPackageDetail(false);
    };

    const onHideUpload = () => {
        setUploadShow(false);
    };

    const onSuccessUpload = () => {
        setUploadShow(false);
        toast.success("Invoice Uploaded");
        window.location.reload();
    };

    const onHideSoftStop = () => {
        setShowSoftStop(false);
    };

    const onSuccessSoftStop = async () => {
        setShowSoftStop(false);
        handles();
        if (selectedRow?.length > 0) {
            const selectedIds = selectedRow.map((val) => {
                return val?.Waybill;
            });
            const data = {
                id: selectedIds,
            };
            const res = await dispatch(handlePostRequest(data, "/deletePackage", true, true));
            if (res?.success) {
                getBrands();
                toast.success("packages deleted");
                window.location.reload();
            }
        }
    };

    const onHideScan = () => {
        setScanPending(false);
        window.location.reload();

    }

    const onSuccessScan = () => {
        setScanPending(false);
        toast.success("Scan Completed");
        window.location.reload();
        window.location.reload();
    }
    return (
        <>
            <Dialog visible={showOutstanding} style={{ width: "650px" }} onHide={() => onHideOutstanding()}>
                <Outstanding onHideOutStanding={onHideOutstanding} onSuccessOutstanding={onSuccessOutstanding} />
            </Dialog>
            <Dialog visible={showDialog} header="Packages" style={{ width: "650px" }} onHide={() => setShowDialog(false)}>
                <AddPackageDialog onHideTyreBrandsDialog={onHideTyreBrandsDialog} onsuccess={onsuccess} trackingNumber={trackingNumber}/>
            </Dialog>

            <Dialog visible={showChangeDialog} header="Package Status Change" style={{ width: "650px" }} onHide={() => setShowChangeDialog(false)}>
                <ChangeStatusDialog onHideChangeDialog={onHideChangeDialog} onsuccessChange={onsuccessChange} data={updates} id={wayBills} unpaid={unpaid}/>
            </Dialog>

            <Dialog visible={FlightDialog} header="Bulk Flight Number Change" style={{ width: "650px" }} onHide={() => setFlightDialog(false)}>
                <BulkFlightDialog onHideChangeDialog={onHideFlightDialog} onsuccessChange={onsuccessFlight} data={selectedRow}></BulkFlightDialog>
            </Dialog>

            <Dialog visible={packageDetail} header="Package Detail" style={{ width: "750px" }} breakpoints={{ "960px": "85vw", "640px": "95vw" }} className={styles.detailDialog} onHide={() => setPackageDetail(false)}>
                <PackageDetail onHideChangeDialog={onHidePackageDetail} onsuccessChange={onsuccessPackageDetail} data={pack}></PackageDetail>
            </Dialog>

            <Dialog visible={uploadShow} header="Upload Invoice" style={{ width: "650px" }} onHide={() => setUploadShow(false)}>
                <UploadImageDialog onHideUpload={onHideUpload} onSuccessUpload={onSuccessUpload} pack={pack}></UploadImageDialog>
            </Dialog>

            {/* <Dialog visible={scanPending} header="Scan for pending packages" style={{ width: "650px" }} onHide={() => setScanPending(false)}>
                <ScanDialog onHideScan={onHideScan} onSuccessScan={onSuccessScan}/>
            </Dialog> */}

            <Dialog visible={showSoftStop} style={{ width: "650px" }} onHide={() => setShowSoftStop(false)}>
                <SofStop onHideSoftStop={onHideSoftStop} onSuccessSoftStop={onSuccessSoftStop} type="package"></SofStop>
            </Dialog>
        </>
    );
}

export default DialogsMain;
